export default __webpack_public_path__ + "static/media/gn.26894d43.svg";